var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.requestVacationsBadgeQTY)?_c('v-chip',{attrs:{"color":"red","text-color":"white","small":""}},[_vm._v(_vm._s(_vm.requestVacationsBadgeQTY))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }